/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetDeletedFilesMetadataByScopeIdsMutationResponse } from "../../models/filesController/FilesControllerGetDeletedFilesMetadataByScopeIds";

function getFilesControllerGetDeletedFilesMetadataByScopeIdsUrl() {
  const res = { method: 'POST', url: `/api/v1/files/deleted-metadata-by-scope` as const }  
  return res
}

/**
 * @description Returns deletion metadata (fileName, deletedAt) for files that have been soft-deleted, queried by scope IDs.
 * @summary Get metadata for deleted files by scope IDs
 * {@link /api/v1/files/deleted-metadata-by-scope}
 */
export async function filesControllerGetDeletedFilesMetadataByScopeIds(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerGetDeletedFilesMetadataByScopeIdsMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getFilesControllerGetDeletedFilesMetadataByScopeIdsUrl().url.toString(), ... requestConfig })  
  return res.data
}